var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary full mb-3 radius-0 f13 h-100",on:{"click":_vm.add}},[_vm._v("\n    Add Prova\n  ")]),_vm._v(" "),_vm._l((_vm.evaluations),function(evaluation,key){return _c('div',{key:key},[_c('EvaluationForm',{staticClass:"mt-3 pb-3",attrs:{"evaluation":evaluation,"job_id":_vm.job_id}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }